import { useEffect, useState } from "react"
import { AccountEditor } from "../../../../../editor/AccountEditor"
import useDataBean from "../../../../../../core/services/dataBean/useDataBean"
import { _single, _UBLInvoice } from "../../../../../../core/services/dataBean/EntityCatalog"
import { FileInput } from "../../../../../theme/Component/FileInput"
import { BasicSwitch } from "../../../../../theme/Component/BasicSwitch"
import { InputDate } from "../../../../../theme/Input/InputDate"
import { BasicButton } from "../../../../../theme/Component/BasicButton"
import { PrintJson } from "../../../../../theme/Component/PrintJson"
import { BasicTable, MASK_BOOLEAN, MASK_DATE, MASK_MONEY, MASK_NUMBER } from "../../../../../theme/Component/BasicTable"
import { ListMenu } from "../../../../../theme/Component/ListMenu"
import { Modal } from "../../../../../theme/Component/Modal"
import { FileService } from "../../../../../../core/services/FileService"
import { HistoryUBLInvoice } from "../HistoryUBLInvoice"
import { Singleton } from "../../../../../../core/services/Singleton"
import { CreateUBLInvoiceItems } from "./CreateUBLInvoiveItem"
import { SelectAccountantConceptForCashDesk } from "./SelectAccountantConceptForCashDesk"
import { FireElectronicDocument } from "../FireElectronicDocument/FireElectronicDocument"
import { AccountantDocumentList } from "../AccountantDocumentList/AccountantDocumentList"
import { SelectAccountantConceptCatalogForSalesInvoice } from "../SelectAccountantConceptCatalogForSalesInvoice"
import { SelectAccountantConceptCatalogForSupplierInvoice } from "../SelectAccountantConceptCatalogForSupplierInvoice"
import { SelectBusinessCore } from "../../../../../erp/cellEditor/BusinessCore/SelectBusinessCore"
import { SelectProject } from "../../../../../erp/cellEditor/BudgetAccountantOperation/SelectProject"
import { toast } from "react-toastify"
import { DocumentViewer } from "../../../../../theme/Component/DocumentViewer"
import { SelectStoreEditor } from "../SelectStore.editor"
import { InputMoney } from "../../../../../theme/Input/InputMoney"
import { PrepaidPaymentEditor } from "./ComponentPrepaidPayment/PrepaidPaymentEditor"
import { ca } from "date-fns/locale"
import { ReciablePaymentEditor } from "./ComponentPrepaidPayment/ReciablePaymentEditor"
import { SelectUBLDocumentPaymentType } from "./Components/SelectUBLDocumentPaymentType"
import useModal, { MODAL_LG, MODAL_md } from "../../../../../theme/Component/hooks/useModal"
import { CurrencyEditor } from "../../../../../erp/cellEditor/Currency/CurrencyEditor"
import { EditorPriceList } from "../../../../../Factoty&Production/PriceList/EditorPriceList"
import { InventoryRemissionFactory } from "../../../../../RemoteAbstractAction/components/account/documents/inventoryremission/InventoryRemissionFactory/InventoryRemissionFactory"
import { UBLInvoiceFactory } from "../../../../../RemoteAbstractAction/components/account/documents/ublsalesaccountantdocument/UBLInvoiceFactory/UBLInvoiceFactory"
import { UBLInvoiceTaxSupplier } from "../../UBLInvoiceSupplier/Component/UBLInvoiceTax/UBLInvoiceTaxSupplier"
import { UBLPaymentMeansEditor } from "../../../../../Inventories-Warehouses/Product/UBLPaymentMeans/UBLPaymentMeansEditor"
import { UBLPaymentMeansCodeEditor } from "../../../../../Inventories-Warehouses/Product/UBLPaymentMeansCode/UBLPaymentMeansCodeEditor"
import { SelectUBLSoftwareDispatcherByEnvironmentType } from "../FireElectronicDocument/Selectores/SelectUBLSoftwareDispatcherByEnvironmentType"
import { VisorAnyDocument } from "../../../../../documents/VisorAnyDocument"
import { UBLNotification } from "../UBLNotification/UBLNotification";

interface Props {
    _onChange2?: Function;
    _idAccount?: number;
    _entry?: "Accounting" | "CashReimbursement";
    typeDocument: "sell" | "Supplier";
    initialInvoice?: any;
    embedded?: boolean;
    onSaved?: (invoice?: any) => void;
}

const PURCHASE_INVOICE = 0;
const BILL_OF_SALE = 1;

export interface DocumentPDF {
    MediaContext: string;
    Media: string;
    Filename: string;
    Type: string;
    URLLink: string | null;
}

export const CreateUBLInvoice = ({ _onChange2, _idAccount, _entry, typeDocument = "sell", initialInvoice, embedded = false, onSaved }: Props) => {

    const _ubl = useDataBean(_UBLInvoice);
    const fileService = new FileService();
    const single = Singleton.getInstance();
    const modifiAnyWay = _single.getSessionItem("canModifiUBL") ? JSON.parse(_single.getSessionItem("canModifiUBL")) : false;
    const [ublsoftware, setUblSofteare] = useState<number>();

    const [recordDate, setRecordDate] = useState<any>(_single.getCurrenDate());
    const [file, setFile] = useState<any>({});
    const [urlFile, setUrlFile] = useState<string | null>(null);
    const [donwloadURL, setDonwloadURL] = useState<string>(null);
    const [obs, setObs] = useState<string>(" ");
    const [fileType, setFileType] = useState<string>(null);
    const [document, setDocument] = useState<any>([]);
    const [documentError, setDocumentError] = useState<any>([]);
    const [formato, setFormato] = useState<any>(null)
    const [type, settype] = useState<any>([]);

    useEffect(() => {
        if (donwloadURL) {
            const fetchPdf = async () => {
                try {
                    const data = await fileService.getPdfAsBase642(donwloadURL);
                    setUrlFile(data);
                } catch (error) {
                    console.error('Error loading PDF:', error);
                }
            };

            fetchPdf();
        }
    }, [donwloadURL]);

    useEffect(() => {
        return () => { _ubl.setBean({}) }
    }, [])

    useEffect(() => {
        if (!initialInvoice) return;

        _ubl.setBean(initialInvoice);
        _ubl.setLista([{ DataBeanProperties: initialInvoice }]);
    }, [initialInvoice])

    useEffect(() => {
        if (file.Media || file.MediaContext) {
            _ubl.setBean({ ..._ubl.bean, "Media": file.Media, "MediaContext": file.MediaContext });
        }
    }, [file])

    useEffect(() => {
        setFileType(_ubl.bean.MediaContext?.type || _ubl.bean.Media?.split('.').pop())
        setDonwloadURL(fileService.getUrlFile(_ubl.bean.MediaContext, _ubl.bean.Media))
    }, [_ubl.bean])

    const createUBLInvoice = () => {

        if (typeDocument === "sell") {
            if (_ubl.bean.IDBusinessCore == null || _ubl.bean.IDProject == null) {
                toast.error("Debe seleccionar un Core de Negocio y un Proyecto");
            } else {
                _ubl.instance.createUBLInvoiceForSales13(
                    _ubl.bean.IDAccountCustomer,
                    _ubl.bean.IDStore,
                    parseInt(_ubl.bean.IDAccountantConcept),
                    _ubl.bean.IssueDate,
                    _ubl.bean.Media,
                    _ubl.bean.MediaContext,
                    single.getAccountID(),
                    obs,
                    _ubl.bean.IDBusinessCore,
                    _ubl.bean.IDProject,
                    _ubl.bean.IDPriceList,
                    _ubl.bean.IFRIDDocument,
                    _ubl.bean.IFRDate
                ).then(
                    (resp: any) => {
                        if (_ubl.bean.IDUBLPaymentMeans | _ubl.bean.IDUBLPaymentMeansCode) {
                            _ubl.instance.updateUBLInvoice({ ...resp, IDUBLPaymentMeansCode: _ubl.bean.IDUBLPaymentMeansCode, IDUBLPaymentMeans: _ubl.bean.IDUBLPaymentMeans }).then(
                                (resp) => {
                                    _ubl.setBean(resp);
                                    let temp = [];
                                    temp.push({
                                        DataBeanProperties: resp
                                    });

                                    _ubl.setLista(temp);
                                }
                            ).catch(
                                err => { console.log(err) }
                            )
                        } else {

                            _ubl.setBean(resp);
                            let temp = [];

                            temp.push({
                                DataBeanProperties: resp
                            });

                            _ubl.setLista(temp);
                        }
                    }
                ).catch(err => { toast.error(err) });
            }
        } else {
            _ubl.instance.createUBLInvoice(
                PURCHASE_INVOICE,
                _ubl.bean.IDStore,
                parseInt(_ubl.bean.IDAccountantConcept),
                _idAccount ?? _ubl.bean.IDAccount,
                _ubl.bean.InvoiceID + "",
                _ubl.bean.isDocumentSupport ?? false,
                _ubl.bean.IssueDate,
                _ubl.bean.accountantDate,
                _ubl.bean.Media,
                _ubl.bean.MediaContext,
                single.getAccountID(),
                obs,
                null,
                null
            ).then(
                (resp: any) => {
                    if (_ubl.bean.IDUBLPaymentMeans | _ubl.bean.IDUBLPaymentMeansCode) {
                        _ubl.instance.updateUBLInvoice({ ...resp, IDUBLPaymentMeansCode: _ubl.bean.IDUBLPaymentMeansCode, IDUBLPaymentMeans: _ubl.bean.IDUBLPaymentMeans }).then(
                            (resp) => {
                                _ubl.setBean(resp);
                                let temp = [];
                                temp.push({
                                    DataBeanProperties: resp
                                });

                                _ubl.setLista(temp);
                            }
                        ).catch(
                            err => { console.log(err) }
                        )
                    } else {

                        _ubl.setBean(resp);
                        let temp = [];

                        temp.push({
                            DataBeanProperties: resp
                        });

                        _ubl.setLista(temp);
                    }
                }
            ).catch(err => { toast.error(err) });
        }
        if (
            _ubl.bean.IDBusinessCore == null ||
            _ubl.bean.IDProject == null
        ) {
            toast.error("Debe seleccionar un Core de Negocio y un Proyecto");
        } else {

        }
    }

    const getUblInvoice = () => {
        _ubl.instance.getUblInvoice(_ubl.bean.IDUBLInvoice, _ubl.bean.IssueDate)
            .then((resp) => {
                //console.log("Respuesta de la factura:", resp);
                const updatedList = _ubl.lista.map((item) => {
                    if (item.DataBeanProperties.IDUBLInvoice === resp.IDUBLInvoice) {
                        return { DataBeanProperties: { ...item.DataBeanProperties, ...resp } };
                    }
                    return item;
                });

                _ubl.setLista(updatedList);
            })
            .catch((err) => {
                //console.log("Error al obtener la factura:", err);
            });
    };

    const head = [
        { title: 'ID Factura', property: 'IDUBLInvoice', visible: true, mask: MASK_NUMBER },
        { title: 'Cliente', property: 'AccountCustomerName', visible: true },
        { title: 'Tipo UBL', property: 'UBLDocumentTypeName', visible: true },
        { title: 'Proveedor', property: 'AccountSupplierName', visible: true },
        { title: 'No Factura', property: 'InvoiceID', visible: true },
        { title: 'Líneas Factura', property: 'LineCountNumeric', visible: true },
        { title: 'Valor Total', property: 'TotalInvoiceAmount', visible: true, mask: MASK_MONEY },
        { title: 'Impuesto', property: 'TaxAmount', visible: true },
        { title: 'Descuentos', property: 'DiscountAmount', visible: true },
        { title: 'Aplicar Anticipo', property: 'ApplyPrepaidValue', visible: true, mask: MASK_BOOLEAN },
        { title: 'Valor del Anticipo', property: 'PrepaidPayment', visible: true, mask: MASK_MONEY },
        { title: 'Fecha Factura', property: 'IssueDate', visible: true, mask: MASK_DATE },
        { title: 'Documento Factura', property: 'Doc', visible: true },
        { title: 'Lista de Precios', property: 'PriceListName', visible: true },
        { title: 'Documento IFR', property: 'IFRConsecutive', visible: true },
        { title: 'Entrada de Almacén/Remisión', property: 'Remision', visible: true },
        { title: 'Estado Factura', property: 'DocumentStateName', visible: true },
        { title: 'Tipo Factura', property: 'SourceTypeName', visible: true },
        { title: 'Estado EAF', property: 'EAFDocumentStateName', visible: true },
        { title: 'Documento Soporte', property: 'IsDocumentSupport', visible: true, mask: MASK_BOOLEAN },
        { title: 'Concepto de Ingreso', property: 'AccountantConceptName', visible: true },
        { title: 'Cuenta Contable', property: 'AccountantIDName', visible: true },
        { title: 'Cuenta Puente Ingreso Bienes', property: 'CreditAccountantIDName', visible: true },
        { title: 'Tipo de Pago', property: 'PaymentTypeName', visible: true },
        { title: 'Días de Vencimiento', property: 'DefeatDays', visible: true },
        { title: 'Utilizar Otra Moneda', property: 'UseOtherCurrency', visible: true },
        { title: 'Moneda de la Transacción', property: 'CurrencyName', visible: true },
        { title: 'Tasa de cambio', property: 'ExchangeRate', visible: true },
        { title: 'Pertenece a Proceso', property: 'ProcessTypeName', visible: true },
    ]

    const [modalB, setModalB] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-xl' });
    const [modalFire, setModalFire] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalSeeDoc, setModalSeeDoc] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalAccounting, setModalAccounting] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalVisor, setModalVisor] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalCustomer, setModalCustomer] = useState<any>({ tabIndex: -1, view: false, btnClose: false, btnSubmit: true, format: 'modal-md' });
    const [modalPrepaid, setModalPrepaid] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalPro, setModalPro] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalApplyPrepaid, setModalApplyPrepaid] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalviewdoc, setModalviewdoc] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-xl' });
    const modalConfig = useModal("Especificar Divisa", MODAL_md)
    const modalConfig2 = useModal("Terminos de Pago", MODAL_md)
    const [modalRetenciones, setModalRetenciones] = useState<any>({ view: false, btnClose: true, btnSubmit: false, format: 'modal-xl' });
    const [modalDocument, setModalDocument] = useState<any>({ view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const modalRadian = useModal("Eventos Radian", MODAL_LG);

    const listaBotones = () => {
        const botones = [
            { titulo: 'Eventos Radian', icono: 'ri-list-check', visible: _single.canView(), evento: () => { modalRadian.open() } },
            { titulo: 'ver Items de la Factura', icono: 'ri-list-ordered', visible: true, evento: () => { setModalB({ ...modalB, "view": true, "name": `Items de la Factura ${_ubl.bean.IDUBLInvoice}` }) } },
            { titulo: 'Ver Retenciones de la Factura', icono: 'ri-list-ordered', visible: true, evento: () => { setModalRetenciones({ ...modalRetenciones, "view": true, "name": `Items de la Factura ${_ubl.bean.IDUBLInvoice}` }) } },
            { titulo: 'Cruzar Anticipo', icono: 'ri-swap-box-line', visible: true, evento: () => { setModalPrepaid({ ...modalPrepaid, "view": true, "name": "Cruzar Anticipo" }) } },
            { titulo: 'Generar Factura Proforma', icono: 'ri-swap-box-line', visible: true, evento: () => { setModalPro({ ...modalPro, "view": true }) } },
            { titulo: 'Aplicar Anticipo', icono: 'ri-money-dollar-circle-line', visible: _ubl.bean.ApplyPrepaidValue === true, evento: () => { setModalApplyPrepaid({ ...modalApplyPrepaid, "view": true, "name": "Aplicar Anticipo" }) } },
            { titulo: 'Actualizar Consumidor', icono: 'ri-person-line', visible: (_ubl.bean.SourceType === 7 || modifiAnyWay), evento: () => { setModalCustomer({ ...modalCustomer, "view": true, "name": "Actualizar Consumidor" }) } },
            { titulo: 'Especificar Divisa', icono: 'ri-money-dollar-box-line', visible: true, evento: () => { modalConfig.open() } },
            { titulo: 'Terminos de Pago', icono: 'ri-money-dollar-box-line', visible: true, evento: () => { modalConfig2.open() } },
            { titulo: 'Agregar/Modificar Documento de Factura', icono: 'ri-swap-line', visible: true, evento: () => { setModalDocument({ ...modalDocument, "name": "Modificar Documento Cargado", "view": true }) } },
            { titulo: 'Anular', icono: 'ri-forbid-line', visible: true, evento: () => { setModalConfirm({ ...ModalConfirm, "view": true, "name": "Anular Factura" }); setObs("") } },
            { titulo: 'Abrir Documento de Factura', icono: 'ri-file-list-line', visible: true, evento: () => { setModal({ ...modal, "name": "Abrir archivo", "view": true, "format": `${fileType !== "pdf" && "jpg" && "png" ? "modal-sm" : "modal-xl"}` }) } },
            { titulo: 'Ver eventos en la Factura', icono: 'ri-history-line', visible: true, evento: () => { setModalC({ ...modalC, "view": true, "name": "Ver eventos en la Factura" }) } },
            { titulo: 'Ver Documentos Contables', icono: 'ri-list-ordered', visible: true, evento: () => { setModalSeeDoc({ ...modalSeeDoc, "view": true, "name": `Ver Documentos Contables` }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [ModalConfirm, setModalConfirm] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    const nullUBL = () => {
        _ubl.instance.nullifyUBLInvoice(_ubl.bean.IDUBLInvoice, _ubl.bean.IssueDate, _single.getAccountID(), obs).then(
            (resp) => {
                _ubl.setBean({})
                _ubl.setLista([]);
                setObs("");
                if (resp.length > 0) {
                    resp.map((e) => {
                        setModalConfirm({ ...ModalConfirm, "view": false });
                        toast.info(e, { autoClose: false });
                    });
                } else {
                    toast.error("No se ha podido anular la factura.")
                }
            }
        ).catch(
            err => {
                console.log(err);
            }
        )
    }

    const setRowBean = (bean: any) => {
        if (_onChange2) {
            _onChange2(bean)
        }
        _ubl.setBean(bean)
    }

    const createAccountantDocumentForUBLInvoice = () => {
        _ubl.instance.createAccountantDocumentForUBLInvoice(_ubl.bean.IDUBLInvoice, _ubl.bean.IssueDate, recordDate, _single.getAccountID())
            .then(
                (resp: any) => {
                    //console.log(resp);
                    if (resp.MsgList) {
                        setDocumentError(resp.MsgList);
                    }
                    if (resp.DocumentURL) {
                        let docs: DocumentPDF[] = [];
                        resp.DocumentURL.forEach(element => {
                            docs.push({
                                Filename: element.DataBeanProperties.Filename,
                                Media: element.DataBeanProperties.Media,
                                MediaContext: element.DataBeanProperties.MediaContext,
                                Type: element.DataBeanProperties.Type,
                                URLLink: element.DataBeanProperties.URLLink
                            })
                        });
                        setDocument(docs);
                    }
                    setModalVisor({ ...modalVisor, "view": true });
                    setModalAccounting({ ...modalAccounting, "view": false });
                }
            ).catch(err => toast.error(err));
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            if (_ubl.bean.IDUBLInvoice) {
                updateInvoice();
            } else {
                createUBLInvoice();
            }
        }
    }
    const getFileType = (mediaName: string) => {
        let fileType = mediaName.split('.').pop()?.toLowerCase();
        return fileType;
    }
    const getElectronicDocumentProforma = () => {

        _ubl.instance.getElectronicDocumentProforma(
            _ubl.bean.IDUBLInvoice,
            _ubl.bean.IssueDate,
            _single.getAccountID(),
            ublsoftware
        ).then((resp: any) => {

            console.log("RESP:", resp);

            let data = resp;

            // 🔥 VALIDACIÓN CLAVE
            if (!data?.MediaContext || !data?.Media) {
                console.warn("No viene MediaContext o Media");
                toast.error("No se encontró el documento para visualizar");
                return; // ⛔ corta ejecución
            }

            const url = fileService.getUrlFile(data.MediaContext, data.Media);
            const type = getFileType(data.Media);

            settype(type);
            setFormato(url);

            // 🔥 primero cerrar
            setModalPro(prev => ({ ...prev, view: false }));

            // 🔥 luego abrir
            setTimeout(() => {
                setModalviewdoc(prev => ({ ...prev, view: true }));
            }, 100);

        }).catch(err => {
            console.error(err);
            toast.error(err);
        });
    };
    const updateInvoice = () => {
        if (_ubl.bean.ApplyPrepaidValue) {
            if (!_ubl.bean?.PrepaidIDAccountantStr || _ubl.bean?.PrepaidIDAccountantStr.trim() === "") {
                toast.error("Debe seleccionar la cuenta contable del anticipo.");
                return;
            }
            if (!_ubl.bean.PrepaidPayment || isNaN(_ubl.bean.PrepaidPayment) || _ubl.bean.PrepaidPayment <= 0) {
                toast.error("Debe ingresar un valor válido del anticipo.");
                return;
            }
        }
        _ubl.instance.updateUBLInvoice(_ubl.bean).then(
            (resp) => {
                _ubl.setBean(resp);
                let temp = [];
                temp.push({
                    DataBeanProperties: resp
                });

                _ubl.setLista(temp);
                setModalCustomer({ ...modalCustomer, "view": false });
                setModalApplyPrepaid({ ...modalApplyPrepaid, "view": false });
                onSaved?.(resp);
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const validateForm = () => {
        let requiredFields = [];
        if (typeDocument === "sell") {
            requiredFields = [
                "IDStore", "IDAccountantConcept", "IssueDate", "IDBusinessCore", "IDProject", "IDAccountCustomer"
            ];
        } else {
            requiredFields = [
                "IDStore", "IDAccountantConcept", "IDAccount", "IssueDate", "accountantDate", "InvoiceID"
            ];
        }

        let missing = [];
        for (let field of requiredFields) {
            if (_ubl.bean[field] === null || _ubl.bean[field] === undefined || _ubl.bean[field] === "") {
                missing.push(field);
            }
        }

        //console.log(missing)
        setMissingFields(missing);
        return missing.length
    };

    const applyPreapid = () => {
        if (_ubl.bean.ApplyPrepaidValue) {
            if (!_ubl.bean.PrepaidIDAccountantStr || _ubl.bean?.PrepaidIDAccountantStr.trim() === "") {
                toast.error("Debe seleccionar la cuenta contable del anticipo.");
                return;
            }
            if (!_ubl.bean.PrepaidPayment || isNaN(_ubl.bean.PrepaidPayment) || _ubl.bean.PrepaidPayment <= 0) {
                toast.error("Debe ingresar un valor válido del anticipo.");
                return;
            }
        }
        _ubl.instance.applyPrepaidPayment(_ubl.bean.IDUBLInvoice, _ubl.bean.IssueDate, _ubl.bean.ApplyPrepaidValue, _ubl.bean.ApplyPrepaidValue ? _ubl.bean.PrepaidIDAccountantStr : null, _ubl.bean.ApplyPrepaidValue ? _ubl.bean.PrepaidPayment : null).then(
            (resp) => {
                _ubl.setBean(resp);
                let temp = [];
                temp.push({
                    DataBeanProperties: resp
                });

                _ubl.setLista(temp);
                setModalPrepaid({ ...modalPrepaid, "view": false });
            }
        ).catch(err => (console.log(err)))
    }

    const [dataUBL, setDataUBL] = useState<string>("");
    const [disableProject, setDisableProject] = useState<boolean>(false);

    return (
        <>
            <div className="row">
                <div className="col-md-6">
                    <UBLPaymentMeansEditor
                        render={_ubl.bean.PaymentMeansID}
                        idSelector={_ubl.bean.IDUBLPaymentMeans}
                        onChange={(e) => _ubl.setBean({ ..._ubl.bean, IDUBLPaymentMeans: e, })
                        }
                    />
                </div>
                <div className="col-md-6">
                    <UBLPaymentMeansCodeEditor
                        render={_ubl.bean.PaymentMeansCode}
                        idSelector={_ubl.bean.IDUBLPaymentMeansCode}
                        onChange={(e) => _ubl.setBean({ ..._ubl.bean, IDUBLPaymentMeansCode: e })}
                    />
                </div>
            </div>
            <div className="row">
                {typeDocument === "sell" ?
                    <div className="col-md-6">
                        {_entry == "CashReimbursement" ?
                            <>
                                <label className={`${missingFields.includes('IDAccountantConcept') ? 'has-error' : ''}`}>Concepto de Ingreso de Facturación</label>
                                <SelectAccountantConceptForCashDesk _label=" " idSelector={_ubl.bean.IDAccountantConcept} onChange={(e) => { _ubl.setBean({ ..._ubl.bean, "IDAccountantConcept": e }) }} />
                            </>
                            :
                            <>
                                <label className={`${missingFields.includes('IDAccountantConcept') ? 'has-error' : ''}`}>Concepto de Ingreso de Facturación de Venta</label>
                                <SelectAccountantConceptCatalogForSalesInvoice label=" " idSelector={_ubl.bean.IDAccountantConcept} onChange={(e) => { _ubl.setBean({ ..._ubl.bean, "IDAccountantConcept": e }) }} />
                            </>
                        }
                    </div>
                    :
                    <>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('IDAccountantConcept') ? 'has-error' : ''}`}>Concepto de Ingreso de Facturación Proveedor</label>
                            <SelectAccountantConceptCatalogForSupplierInvoice label=" " idSelector={_ubl.bean.IDAccountantConcept} onChange={(e) => { _ubl.setBean({ ..._ubl.bean, "IDAccountantConcept": e }) }} />
                        </div>
                    </>

                }

                <div className="col-md-6">
                    <label className={`${missingFields.includes('IDStore') ? 'has-error' : ''}`}>Almacen</label>
                    <SelectStoreEditor idSelector={_ubl.bean.IDStore} onChange={(e) => { _ubl.setBean({ ..._ubl.bean, "IDStore": e.IDStore }) }} label=" " />
                </div>

                {typeDocument === "sell" &&
                    <>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('IDProject') ? 'has-error' : ''}`}>Proyecto</label>
                            <SelectProject
                                disabled={disableProject}
                                label=" "
                                idSelector={_ubl.bean.IDProject}
                                onChange={(value) => {
                                    if (!value) {
                                        _ubl.setBean({
                                            ..._ubl.bean,
                                            IDProject: null,
                                            IDAccount: null,
                                            IDBusinessCore: null
                                        });
                                        return;
                                    }

                                    const { IDProject, IDAccount, IDBusinessCore } = value;
                                    _ubl.setBean({
                                        ..._ubl.bean,
                                        IDProject: IDProject ?? null,
                                        IDAccountCustomer: IDAccount ?? null,
                                        IDBusinessCore: IDBusinessCore ?? null
                                    });
                                }}
                                returnType="Object"
                            />

                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('IDBusinessCore') ? 'has-error' : ''}`}>Core de Negocio</label>
                            <SelectBusinessCore label=" " idSelector={_ubl.bean.IDBusinessCore} onChange={(e) => { _ubl.setBean({ ..._ubl.bean, "IDBusinessCore": e }) }} />
                        </div>

                        <div className="col-md-6">
                            <label className={`${missingFields.includes('IDAccountCustomer') ? 'has-error' : ''}`}>Consumidor</label>
                            <AccountEditor idAccount={_ubl.bean.IDAccountCustomer} label=" " onChange={(e) => { _ubl.setBean({ ..._ubl.bean, "IDAccountCustomer": e.IDAccount }); }} />
                        </div>
                    </>
                }

                {typeDocument === "Supplier" &&
                    <div className="col-md-6">
                        <label className={`${missingFields.includes('IDAccount') ? 'has-error' : ''}`}>Tercero</label>
                        <AccountEditor disabled={(typeof _idAccount === "number" && _idAccount >= 0)} idAccount={_idAccount ?? _ubl.bean.IDAccount} label=" " onChange={({ IDAccount }: any) => { _ubl.setBean({ ..._ubl.bean, "IDAccount": IDAccount }) }} />
                    </div>
                }

                <div className="col-md-6">
                    <FileInput Media={_ubl.bean.Media} MediaContext={_ubl.bean.MediaContext} label={`Archivo ${typeDocument == "Supplier" ? "Factura" : "Remisión"}`} directory="temp" onCreate={(e) => { setFile(e) }} />
                </div>

                {typeDocument === "sell" &&
                    <>
                        <div className="col-md-6">
                            <label>Traer Datos desde:</label>
                            <select className="form-control" value={dataUBL} onChange={(e) => {
                                setDataUBL(e.target.value);
                                setDisableProject(false);
                            }}>
                                <option value="">...</option>
                                <option value="Remision">Remisión</option>
                                <option value="Third">Facturas Pagadas a Terceros por Proyecto</option>
                            </select>
                        </div>
                        {dataUBL === "Remision" &&
                            <div className="col-md-6">
                                <InventoryRemissionFactory
                                    onChangeProyect={(value) => {
                                        const { IDProject, IDAccount, IDBusinessCore } = value;
                                        _ubl.setBean({
                                            ..._ubl.bean,
                                            IDProject: IDProject ?? null,
                                            IDAccount: IDAccount ?? null,
                                            IDBusinessCore: IDBusinessCore ?? null
                                        });
                                        if (IDProject) {
                                            setDisableProject(true);
                                        } else {
                                            setDisableProject(false);
                                        }
                                    }}
                                    onChange={(e) => { _ubl.setBean({ ..._ubl.bean, IFRDate: e.DocumentDate, IFRIDDocument: e.IDDocument }) }}
                                    label="Remisiones de Producto"
                                />
                            </div>
                        }
                        {dataUBL === "Third" &&
                            <div className="col-md-6">
                                <UBLInvoiceFactory
                                    onChange={(e) => {
                                        if (e.IDProject) {
                                            setDisableProject(true);
                                        } else {
                                            setDisableProject(false);
                                        }
                                        _ubl.setBean({ ..._ubl.bean, IFRDate: e.DocumentDate, IFRIDDocument: e.IDDocument, IDProject: e.IDProject })
                                    }}
                                    label="Factura Pagada a Terceros por Proyectos"
                                />
                            </div>
                        }
                        {dataUBL == "" &&
                            <div className="col-md-6" />
                        }
                        <div className="col-md-6">
                            <EditorPriceList selectFirstData={_ubl.bean.IFRIDDocument} onChange={(e) => { _ubl.setBean({ ..._ubl.bean, IDPriceList: e.IDPriceList }) }} label="Listado de precios" />
                        </div>
                    </>
                }

                {typeDocument === "Supplier" &&
                    <>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('InvoiceID') ? 'has-error' : ''}`}>Número de {typeDocument == "Supplier" ? "Factura" : "Remisión"}</label>
                            <input type="text" className="form-control" name="InvoiceID" value={_ubl.bean.InvoiceID} onChange={_ubl.handleChange} />
                        </div>
                        <div className="col-md-6">
                            <BasicSwitch label="Documento Soporte" estado={_ubl.bean.isDocumentSupport} eventChange={(e) => { _ubl.setBean({ ..._ubl.bean, "isDocumentSupport": e }) }} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('accountantDate') ? 'has-error' : ''}`}>Fecha de Registro Contable</label>
                            <InputDate notDate label=" " name="accountantDate" value={_ubl.bean.accountantDate} setDate={(e) => { _ubl.setBean({ ..._ubl.bean, "accountantDate": e }) }} />
                        </div>
                    </>
                }
                <div className="col-md-6">
                    <label className={`${missingFields.includes('IssueDate') ? 'has-error' : ''}`}>Fecha de Factura</label>
                    <InputDate notDate label=" " name="IssueDate" value={_ubl.bean.IssueDate} setDate={(e) => { _ubl.setBean({ ..._ubl.bean, "IssueDate": e }) }} />
                </div>

                <div className="col-md-12">
                    <label>Observaciones</label>
                    <textarea name="obs" className="form-control" value={obs} onChange={(e) => { setObs(e.target.value) }} ></textarea>
                </div>

                <div className="col-md-6 mt-4">
                    <BasicButton icon="ri-save-2-line" eventClick={validateData}>{_ubl.bean.IDUBLInvoice ? "Actualizar" : "Crear"}</BasicButton>
                </div>
            </div>

            {!embedded && <div className="row">
                <div className="col-md-12">
                    <BasicTable body={_ubl.lista} head={head} rowSet={(e) => { setRowBean(e) }} listButtons={listaBotones()} />
                </div>
                {(typeDocument === "sell" && _ubl.bean.IDUBLInvoice) &&
                    <div className="row d-flex justify-content-between mt-4">
                        <div className="col-md-6">
                            <BasicButton eventClick={() => { setModalFire({ ...modalFire, "view": true, "name": `Transmitir/Descargar Documento` }) }} icon="ri-save-line" children={"Transmitir Documento Electrónico"} />
                        </div>
                        <div className="col-md-6 d-flex justify-content-end">
                            <BasicButton eventClick={() => { setModalAccounting({ ...modalAccounting, "view": true, "name": `Contabilizar Factura Electrónica` }) }} icon="ri-save-line" children={"Contabilizar Factura Electrónica"} />
                        </div>
                    </div>
                }
            </div>}

            <Modal modal={modalB} updateModal={setModalB} >
                <CreateUBLInvoiceItems idUBLInvoice={_ubl.bean.IDUBLInvoice} issueDate={_ubl.bean.IssueDate} _onChange={() => { getUblInvoice(); }} />
            </Modal>

            <Modal modal={modalDocument} updateModal={setModalDocument} eventModal={() => { updateInvoice() }} >
                <div className="row">
                    <div className="col-md-12">
                        <label>No Factura</label>
                        <input type="text" className="form-control" value={_ubl.bean.InvoiceID} onChange={(e) => { _ubl.bean.setBean({ ..._ubl.bean.bean, InvoiceID: e.target.value }) }} />
                    </div>
                    <div className="col-md-12">
                        <FileInput onCreate={(e) => { _ubl.bean.setBean({ ..._ubl.bean.bean, Media: e.Media, MediaContext: e.MediaContext }) }} Media={_ubl.bean.Media} MediaContext={_ubl.bean.MediaContext} label={_ubl.bean.Media ? "Documento de la Factura Cargada" : "Cargar Documento de Factura"} />
                    </div>
                </div>
            </Modal>

            <Modal modal={modalRetenciones} updateModal={setModalRetenciones} >
                <UBLInvoiceTaxSupplier idublInvoice={_ubl.bean.IDUBLInvoice} issueDate={_ubl.bean.IssueDate} />
            </Modal>


            <Modal modal={modalRadian.modal} updateModal={modalRadian.setModal} >
                <UBLNotification ublInvoice={_ubl.bean} />
            </Modal>

            <Modal modal={modal} updateModal={setModal} eventModal={() => { }} >
                <div className="row">
                    <div className="col-md-12">
                        <div className="iframe-container">

                            {fileType ?
                                <>
                                    <PrintJson json={fileType} />
                                    {fileType === 'pdf' && (
                                        urlFile ? (
                                            <iframe name="pdfviwer" src={urlFile} onError={(e) => console.error('Error loading PDF:', e)}></iframe>
                                        ) : (
                                            <p>Cargando PDF...</p>
                                        )
                                    )}
                                    {fileType === `"jpg"` || fileType === "png" &&
                                        (
                                            <img src={urlFile} alt="Image Preview" width="100%" />
                                        )
                                    }
                                    {fileType !== "pdf" && "jpg" && "png" &&
                                        <>
                                            <a href={donwloadURL} target='_blank'>Clic aquí para descargar el archivo {_ubl.bean.Media}</a>
                                        </>
                                    }
                                </>
                                :
                                <>
                                    No se pudo cargar el Documento
                                </>
                            }
                        </div>
                    </div>
                </div>
            </Modal>

            <Modal modal={modalC} updateModal={setModalC} >
                <HistoryUBLInvoice _idUBLInvoice={_ubl.bean.IDUBLInvoice} _isseDate={_ubl.bean.IssueDate} />
            </Modal>

            <Modal modal={modalConfig.modal} updateModal={modalConfig.setModal} eventModal={updateInvoice} >
                <div className="row">
                    <div className="col-md-12">
                        <BasicSwitch label="Utilizar Otra Moneda" estado={_ubl.bean.UseOtherCurrency} eventChange={(e) => { _ubl.setBean({ ..._ubl.bean, UseOtherCurrency: e }) }} />
                    </div>
                    {_ubl.bean.UseOtherCurrency &&
                        <>
                            <div className="col-md-12">
                                <CurrencyEditor id={_ubl.bean.IDCurrency} onchange={(e) => { _ubl.setBean({ ..._ubl.bean, IDCurrency: e }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Tasa de cambio</label>
                                <input type="number" className="form-control" value={_ubl.bean.ExchangeRate} onChange={(e) => {
                                    const value = e.target.value ? parseFloat(e.target.value) : null;
                                    _ubl.setBean({ ..._ubl.bean, ExchangeRate: value })
                                }} />
                            </div>
                        </>
                    }
                </div>
            </Modal>

            <Modal modal={modalConfig2.modal} updateModal={modalConfig2.setModal} eventModal={updateInvoice} >
                <div className="row">
                    <div className="col-md-12">
                        <SelectUBLDocumentPaymentType idSelector={_ubl.bean.PaymentType} label="Tipo de Pago" onChange={(e) => { _ubl.setBean({ ..._ubl.bean, PaymentType: e }) }} />
                    </div>
                    <div className="col-md-12">
                        <label>Dias de Vencimiento</label>
                        <input type="number" className="form-control" value={_ubl.bean.DefeatDays} onChange={(e) => {
                            const value = e.target.value ? Number(e.target.value) : null;
                            _ubl.setBean({ ..._ubl.bean, DefeatDays: value })
                        }} />
                    </div>
                </div>
            </Modal>

            <Modal modal={modalFire} updateModal={setModalFire} >
                <FireElectronicDocument _idUBLInvoice={_ubl.bean.IDUBLInvoice} _isseDate={_ubl.bean.IssueDate} />
            </Modal>

            <Modal modal={modalSeeDoc} updateModal={setModalSeeDoc} >
                <AccountantDocumentList _idUBLInvoice={_ubl.bean.IDUBLInvoice} _isseDate={_ubl.bean.IssueDate} />
            </Modal>

            <Modal modal={modalCustomer} updateModal={setModalCustomer} eventModal={updateInvoice}  >
                <div className="row">
                    <div className="col-md-12">
                        <AccountEditor idAccount={_ubl.bean.IDAccountCustomer} label="Consumidor" onChange={(e) => { _ubl.setBean({ ..._ubl.bean, "IDAccountCustomer": e.IDAccount }); }} />
                    </div>
                </div>
            </Modal>

            <Modal modal={modalPrepaid} updateModal={setModalPrepaid} eventModal={() => { applyPreapid() }}  >
                <div className="row">
                    <div className="col-md-12">
                        <BasicSwitch label="Aplicar Anticipo" estado={_ubl.bean.ApplyPrepaidValue} eventChange={(e) => { _ubl.setBean({ ..._ubl.bean, "ApplyPrepaidValue": e }) }} />
                    </div>
                    <div className="col-md-12">
                        <PrepaidPaymentEditor _Invoice={_ubl.bean} onChange={(e) => { _ubl.setBean({ ..._ubl.bean, "PrepaidIDAccountantStr": e.JsonCode }) }} />
                    </div>
                    <div className="col-md-12">
                        <InputMoney _value={_ubl.bean.PrepaidPayment} onChange={(e) => { _ubl.setBean({ ..._ubl.bean, "PrepaidPayment": e }) }} _label="Valor del Anticipo a Cruzar" />
                    </div>
                </div>
            </Modal>

            <Modal modal={modalPro} updateModal={setModalPro} eventModal={getElectronicDocumentProforma}  >
                <div className="row">
                    <div className="col-md-12">
                        <SelectUBLSoftwareDispatcherByEnvironmentType idSelector={ublsoftware} onChange={(e) => { setUblSofteare(e) }} />
                    </div>
                </div>
            </Modal>
            <Modal modal={modalApplyPrepaid} updateModal={setModalApplyPrepaid} eventModal={() => { updateInvoice() }}  >
                <div className="row">
                    <div className="col-md-12">
                        <BasicSwitch label="Aplicar Anticipo" estado={_ubl.bean.ApplyPrepaidValue} eventChange={(e) => { _ubl.setBean({ ..._ubl.bean, "ApplyPrepaidValue": e }) }} />
                    </div>
                    <div className="col-md-12">
                        <ReciablePaymentEditor renderValue={_ubl.bean.PrepaidIDAccountantStr} _Invoice={_ubl.bean} onChange={(e) => { _ubl.setBean({ ..._ubl.bean, "PrepaidIDAccountantStr": e.JsonCode }) }} />
                    </div>
                    <div className="col-md-12">
                        <InputMoney _value={_ubl.bean.PrepaidPayment} onChange={(e) => { _ubl.setBean({ ..._ubl.bean, "PrepaidPayment": e }) }} _label="Valor del Anticipo a Cruzar" />
                        {/* <label>Valor del Anticipo a Cruzar</label>
                        <input type="number" className="form-control" value={bean.PrepaidPayment} onChange={(e) => { setBean({ ...bean, "PrepaidPayment": parseFloat(e.target.value) }) }} /> */}
                    </div>
                </div>
            </Modal>

            <Modal modal={modalAccounting} updateModal={setModalAccounting} eventModal={createAccountantDocumentForUBLInvoice} onSubmitLabel="Procesar">
                {/* contabilizar la factura electronica */}
                <div className="row">
                    <div className="col-md-12">
                        <InputDate label="Fecha de registro contable" name="date" value={recordDate} setDate={setRecordDate} />
                    </div>
                </div>
            </Modal>

            <Modal modal={modalviewdoc} updateModal={setModalviewdoc}>
                <div className="row">
                    <div className="col-md-12">
                        <VisorAnyDocument url={formato} type={type} />
                    </div>
                </div>
            </Modal>


            <Modal modal={modalVisor} updateModal={setModalVisor} >
                {/* visor de documentos */}
                <div className="row">
                    <div className="col-md-12">
                        {documentError.length > 0 ?
                            // <PrintJson json={documentError} />
                            <ul className="group-list">
                                {documentError.map((item: any, index: number) => {
                                    return (
                                        <li key={index} className="group-list-item">{item}</li>
                                    )
                                })}
                            </ul>
                            :
                            <>
                                {document.length > 0 &&
                                    <DocumentViewer list={document} />
                                }
                            </>
                        }
                    </div>
                </div>
            </Modal>

            <Modal modal={ModalConfirm} updateModal={setModalConfirm} eventModal={() => { nullUBL() }}  >
                <div className="row">
                    <div className="col-md-6">
                        <strong>ID Factura </strong><small>{_ubl.bean.IDUBLInvoice}</small>
                    </div>
                    <div className="col-md-6">
                        <strong>Fecha Factura </strong><small>{_ubl.bean.IssueDate}</small>
                    </div>
                    <div className="col-md-12">
                        <label >Justificación</label>
                        <textarea className="form-control" value={obs} onChange={(e) => { setObs(e.target.value) }} />
                    </div>
                </div>
            </Modal>
        </>
    )
}
